export default {
  name: {
    type: 'string',
    required: true,
  },
  positionIds: {
    type: 'array',
    required: true,
    forEach: {
      type: 'string',
    },
  },
};
